/*
 Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Gallery API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemStatus = 'Unused' | 'Closed' | 'Critical' | 'Affected' | 'Open';

export const ItemStatus = {
    Unused: 'Unused' as ItemStatus,
    Closed: 'Closed' as ItemStatus,
    Critical: 'Critical' as ItemStatus,
    Affected: 'Affected' as ItemStatus,
    Open: 'Open' as ItemStatus
};

